/* Layout repairs preserve the words of page and policy content. */
(() => {
  const apply = () => {
    if (!document.body.classList.contains('sg-b3-scope')) return;
    document.querySelectorAll('#MainContent .rte table, .shopify-policy__body table').forEach((table) => {
      if (table.parentElement.classList.contains('sg-b3-table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'sg-b3-table-scroll';
      wrapper.tabIndex = 0;
      table.before(wrapper);
      wrapper.append(table);
    });
    // Shopify supplies the policy's page-level h1 outside its editable body.
    const policyTitle = document.querySelector('.shopify-policy__title h1');
    if (policyTitle) document.querySelectorAll('.shopify-policy__body h1').forEach((heading) => {
      const replacement = document.createElement('h2');
      Array.from(heading.attributes).forEach(({ name, value }) => replacement.setAttribute(name, value));
      replacement.append(...heading.childNodes);
      heading.replaceWith(replacement);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
  document.addEventListener('shopify:section:load', apply);
})();
